module.exports = __webpack_public_path__ + "media/components/assets/img/icons/card-04beb734c20de34bf5f7b6e79cc8a650.svg";